import {
  GET_COMBO_CUA_HANG,
  GET_COMBO_CUA_HANG_SUCCESS,
  GET_COMBO_CUA_HANG_FAILURE,
  CHUYEN_CUA_HANG,
  CHUYEN_CUA_HANG_SUCCESS,
  CHUYEN_CUA_HANG_FAILURE,
  THONG_TIN_CUA_HANG_HIEN_TAI,
  THONG_TIN_CUA_HANG_HIEN_TAI_SUCCESS,
  THONG_TIN_CUA_HANG_HIEN_TAI_FAILURE,
} from "./actionTypes";

export const getComboCuaHang = (dataSearch) => ({
  type: GET_COMBO_CUA_HANG,
  dataSearch,
});

export const getComboCuaHangSuccess = (data) => ({
  type: GET_COMBO_CUA_HANG_SUCCESS,
  payload: data,
});

export const getComboCuaHangFailure = () => ({
  type: GET_COMBO_CUA_HANG_FAILURE,
});

export const chuyenCuaHang = (dataSearch) => ({
  type: CHUYEN_CUA_HANG,
  dataSearch,
});

export const chuyenCuaHangSuccess = (data) => ({
  type: CHUYEN_CUA_HANG_SUCCESS,
  payload: data,
});

export const chuyenCuaHangFailure = () => ({
  type: CHUYEN_CUA_HANG_FAILURE,
});

export const thongTinCuaHangHienTai = (dataSearch) => ({
  type: THONG_TIN_CUA_HANG_HIEN_TAI,
  dataSearch,
});

export const thongTinCuaHangHienTaiSuccess = (data) => ({
  type: THONG_TIN_CUA_HANG_HIEN_TAI_SUCCESS,
  payload: data,
});

export const thongTinCuaHangHienTaiFailure = () => ({
  type: THONG_TIN_CUA_HANG_HIEN_TAI_FAILURE,
});
